import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { Button } from 'components/Core/Button';
import { noCountriesTranslations } from './translations';
import { NoCountriesTransFields } from './types';
import styles from './noCountries.module.scss';

/** Shown instead of any screen when the admin is logged in but has no selected country. */
export const NoCountries: FC = observer(() => {
  const {
    mainStore: { error, logout, removeProfile },
  } = useStore();

  const { t } = useMyTranslations<NoCountriesTransFields>([noCountriesTranslations.name]);

  // Leaving must always work here, even if the backend rejects the logout call.
  const onLogout = () => logout().catch(removeProfile);

  return (
    <div className={styles.root}>
      <p className={styles.message}>{error?.message || t('message')}</p>
      <Button title={t('logout')} onClick={onLogout} />
    </div>
  );
});
